<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ "menu.signatures.custom" | translate }}</span>
    <div class="actions" *ngIf="hasInstalledSignatures()">
      <button mat-stroked-button type="button" (click)="reinstallSignatures()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        {{ "signatures.reinstall" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="content-wrapper">
    <div
      cdkDropList
      [cdkDropListData]="signatures"
      cdkDropListSortingDisabled="true"
      (cdkDropListDropped)="drop($event)"
      class="signatures-grid"
    >
    <div class="signature-wrapper">
      <div class="signature-card generator-card" (click)="openSignatureChoiceDialog()">
        <div class="signature-content-wrapper generator-wrapper">
          <div class="generator-message">
            <h3>{{ 'signatures.addNewSignature' | translate }}</h3>
            <a mat-stroked-button color="primary">
              <mat-icon>add</mat-icon>
              {{ 'signatures.addNew' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngFor="let signature of signatures; let i = index; trackBy: trackByTemplateId"
      class="signature-wrapper"
      (mouseenter)="onWrapperEnter(i)"
      (mouseleave)="onWrapperLeave(i)"
    >
      <div *ngIf="signature.isPlaceholder" class="signature-placeholder">
        <div class="signature-card">
          <div class="signature-header">
            <div class="name-default-wrapper">
              <div class="name-placeholder shimmer"></div>
            </div>
            <div class="signature-installed">
              <div class="chip shimmer"></div>
            </div>
          </div>

          <div class="signature-content-wrapper">
            <div class="signature-content-skeleton">
              <div class="profile-placeholder">
                <div class="profile-content">
                  <div class="avatar shimmer">
                    <mat-icon class="user-icon">person</mat-icon>
                  </div>
                  <div class="info-placeholder">
                    <div class="name-placeholder shimmer"></div>
                    <div class="title-placeholder shimmer"></div>
                    <div class="contact-placeholders">
                      <div class="contact-placeholder">
                        <mat-icon class="icon">phone</mat-icon>
                        <div class="line shimmer"></div>
                      </div>
                      <div class="contact-placeholder">
                        <mat-icon class="icon">email</mat-icon>
                        <div class="line shimmer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="signature-footer">
            <div class="signature-addons">
              <div class="addon-item shimmer">
                <mat-icon>indeterminate_check_box</mat-icon>
                <span class="shimmer"></span>
              </div>
              <div class="addon-item shimmer">
                <mat-icon>indeterminate_check_box</mat-icon>
                <span class="shimmer"></span>
              </div>
              <div class="addon-item shimmer">
                <mat-icon>indeterminate_check_box</mat-icon>
                <span class="shimmer"></span>
              </div>
            </div>
            <div class="signature-install">
              <div class="install-button shimmer"></div>
            </div>
          </div>
        </div>

        <div class="signature-actions">
          <div class="action-button shimmer"></div>
          <div class="action-button shimmer"></div>
          <div class="action-button shimmer"></div>
          <div class="action-button shimmer"></div>
        </div>
      </div>

      <div *ngIf="!signature.isPlaceholder">
      <div
        cdkDrag
        [cdkDragData]="signature"
        class="signature-card"
        [id]="signature.templateId"
        [class.drop-border-left]="hoveredIndex === i"
        (cdkDragStarted)="dragStarted()"
        (cdkDragEnded)="dragEnded()"
      >
        <div class="signature-header">
          <div class="name-default-wrapper">
            <h4>{{ signature.name }}</h4>
            <button
              *ngIf="!defaultSignatureSet"
              (click)="setDefault(signature)"
              class="chip-button"
              [title]="
                (!auth.lastGoogleSync
                  ? 'signatures.default.setDefaultDisabledTooltip'
                  : 'signatures.default.setDefaultTooltip'
                ) | translate
              "
              [disabled]="!auth.lastGoogleSync"
            >
              {{ 'signatures.default.setDefaultButton' | translate }}
            </button>
            <button
              *ngIf="signature.defaultForNewEmployee"
              (click)="removeDefault(signature)"
              class="chip-button"
              [title]="'signatures.default.unsetDefaultTooltip' | translate"
            >
              <mat-icon>check</mat-icon>
              <span>{{ 'signatures.default.unsetDefaultButton' | translate }}</span>
            </button>
          </div>

          <div class="signature-installed">
            <ng-container
              *ngIf="
                signature.numberOfInstallations > 0 ||
                signature.numberOfAliases > 0 ||
                signature.numberOfInternalInstallations > 0 ||
                signature.numberOfInternalAliases > 0 ||
                hasDomainRulesInstallation(signature);
                else notInstalled
              "
            >
              <div
                *ngIf="
                  signature.numberOfInstallations > 0 ||
                  signature.numberOfAliases > 0
                "
                class="signature-row"
              >
                <div
                  class="signature-label-column"
                  matTooltip="{{ 'externalSignature' | translate }}"
                >
                  <mat-icon aria-label="external">launch</mat-icon>
                </div>
                <div class="signature-name-column">
                  <ng-container>
                    <a
                      [routerLink]="['/employees']"
                      [queryParams]="{ templateId: signature.templateId }"
                      *ngIf="signature.numberOfInstallations > 0"
                    >
                      <span class="chip installed-text" disabled>
                        {{
                          'signatures.installed'
                            | translate:{ installed: signature.numberOfInstallations }
                        }}
                      </span>
                    </a>
                    <a
                      [routerLink]="['/employees']"
                      [queryParams]="{ templateId: signature.templateId, aliases: true }"
                      *ngIf="signature.numberOfAliases > 0"
                    >
                      <span class="chip aliases-installed-text" disabled>
                        {{
                          'signatures.aliasesInstalled'
                            | translate:{ installed: signature.numberOfAliases }
                        }}
                      </span>
                    </a>
                  </ng-container>
                </div>
                <div class="signature-close-column"></div>
              </div>

              <div
                *ngIf="
                  signature.numberOfInternalInstallations > 0 ||
                  signature.numberOfInternalAliases > 0
                "
                class="signature-row"
              >
                <div
                  class="signature-label-column"
                  matTooltip="{{ 'internalSignature' | translate }}"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <title>{{ 'signatures.internalInstallationsTooltip' | translate }}</title>
                    <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z"/>
                    <path d="M16 15v-2h-3.59L20 5.41l-1.41-1.41L11 11.59V8h-2v7h7z"/>
                  </svg>
                </div>
                <div class="signature-name-column">
                  <ng-container>
                    <a
                      [routerLink]="['/employees']"
                      [queryParams]="{ templateId: signature.templateId }"
                      *ngIf="signature.numberOfInternalInstallations > 0"
                    >
                      <span class="chip installed-text" disabled>
                        {{
                          'signatures.installed'
                            | translate:{ installed: signature.numberOfInternalInstallations }
                        }}
                      </span>
                    </a>
                    <a
                      [routerLink]="['/employees']"
                      [queryParams]="{ templateId: signature.templateId, aliases: true }"
                      *ngIf="signature.numberOfInternalAliases > 0"
                    >
                      <span class="chip aliases-installed-text" disabled>
                        {{
                          'signatures.aliasesInstalled'
                            | translate:{ installed: signature.numberOfInternalAliases }
                        }}
                      </span>
                    </a>
                  </ng-container>
                </div>
                <div class="signature-close-column"></div>
              </div>

              <div *ngIf="hasDomainRulesInstallation(signature)" class="signature-row">
                <div
                  class="signature-label-column"
                  matTooltip="{{ 'signatures.domainRules' | translate }}"
                >
                  <mat-icon aria-label="domain-rules">rule</mat-icon>
                </div>
                <div class="signature-name-column">
                  <span
                    class="chip domain-rules-installed-text"
                    (click)="goToDetailsWithDomainRules(signature.templateId, $event)"
                  >
                    {{ "signatures.domainRulesInstalled" | translate }}
                  </span>
                </div>
                <div class="signature-close-column"></div>
              </div>
            </ng-container>

            <ng-template #notInstalled>
              <span class="chip not-installed-text" disabled>
                {{ 'signatures.notInstalled' | translate }}
              </span>
            </ng-template>
          </div>
        </div>

        <div class="signature-content-wrapper" #signatureContentContainer>
          <div
            [innerHTML]="signature.content | safeHtml"
            class="signature-content"
            appScaleContent
            [appScaleContent]="signatureContentContainer"
          ></div>
        </div>

        <div class="signature-footer">
          <div class="signature-addons">
            <div (click)="navigateToAddon('links')" class="addon-item">
              <mat-icon>
                {{
                  signature.addonLinkId ? 'check_box' : 'indeterminate_check_box'
                }}
              </mat-icon>
              {{ 'signatures.link' | translate }}
            </div>
            <div (click)="navigateToAddon('banners')" class="addon-item">
              <mat-icon>
                {{
                  signature.addonBannerId || signature.addonAdditionalBannerId
                    ? 'check_box'
                    : 'indeterminate_check_box'
                }}
              </mat-icon>
              {{ 'signatures.banner' | translate }}
            </div>
            <div (click)="navigateToAddon('disclaimers')" class="addon-item">
              <mat-icon>
                {{
                  signature.addonDisclaimerId
                    ? 'check_box'
                    : 'indeterminate_check_box'
                }}
              </mat-icon>
              {{ 'signatures.disclaimer' | translate }}
            </div>
            <div 
              *ngIf="signature.domainRules && signature.domainRules.length > 0"
              (click)="goToEditSignatureWithDomainRules(signature.templateId)"
              class="addon-item"
              [matTooltip]="getDomainRulesTooltip(signature.domainRules)"
              matTooltipClass="domain-rules-tooltip">
              <mat-icon>check_box</mat-icon>
              {{ 'signatures.domainRules' | translate }}
            </div>
          </div>
          <div class="signature-install">
            <a
              mat-raised-button
              color="primary"
              [routerLink]="['/signatures', signature.templateId]"
            >
              {{ 'install' | translate }}
            </a>
          </div>
        </div>
      </div>

      <div class="signature-actions">
        <a class="action-btn" [routerLink]="['/signatures', signature.templateId, 'edit']">
          <mat-icon>edit</mat-icon>
          {{ 'edit' | translate }}
        </a>
        <button type="button" class="action-btn" (click)="duplicateSignature(signature.templateId)">
          <mat-icon>file_copy</mat-icon>
          {{ 'duplicate' | translate }}
        </button>
        <button type="button" class="action-btn" (click)="copySignatureToClipboard(signature)">
          <mat-icon>content_copy</mat-icon>
          {{ 'copyHTMLToClipboard' | translate }}
        </button>
        <button
          type="button"
          class="action-btn action-btn--danger"
          *ngIf="!signature.numberOfInstallations && !signature.numberOfInternalInstallations && !hasDomainRulesInstallation(signature)"
          (click)="removeSignature(signature.templateId)"
        >
          <mat-icon>delete_outline</mat-icon>
          {{ 'delete' | translate }}
        </button>
      </div>

      <ng-template cdkDragPlaceholder>
        <div class="signature-placeholder"></div>
      </ng-template>
    </div>
  </div>
    </div>

    <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
      <app-loading></app-loading>
    </div>
  </div>
</div>

<!-- <app-tutorial-modal></app-tutorial-modal> -->
